import styles from './hours-badge.module.scss';
import clsx from 'clsx';

export type HoursBadgeType = 'permanent' | 'temporary' | 'closed';

type HoursBadgeProps = {
  hours: string;
  type: HoursBadgeType;
  variant?: 'default' | 'mobile';
};

export function HoursBadge({ hours, type, variant = 'default' }: HoursBadgeProps) {
  return (
    <div
      className={clsx(styles.badge, styles[type], {
        [styles.mobile]: variant === 'mobile',
      })}
    >
      {hours}
    </div>
  );
}
